import { useCallback, useEffect } from 'react';
import { useAuth } from './useAuth';

const STORAGE_KEY = 'lastActivityAt';
const SESSION_START_KEY = 'sessionStartedAt';
const INACTIVITY_LIMIT = 24 * 60 * 60 * 1000; // 24 hours in ms
const MAX_SESSION_DURATION = 7 * 24 * 60 * 60 * 1000; // 7 days absolute max

export function useSessionActivity() {
  const { signOut } = useAuth();

  // On mount: check inactivity timeout AND absolute session duration
  useEffect(() => {
    // Check inactivity timeout
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const lastActivity = Number(stored);
      if (Date.now() - lastActivity > INACTIVITY_LIMIT) {
        signOut();
        return;
      }
    }

    // Check absolute session duration (re-auth after 7 days of continuous use)
    const sessionStart = localStorage.getItem(SESSION_START_KEY);
    if (sessionStart) {
      const startTime = Number(sessionStart);
      if (Date.now() - startTime > MAX_SESSION_DURATION) {
        localStorage.removeItem(SESSION_START_KEY);
        signOut();
        return;
      }
    } else {
      // First activity in this session - record the start time
      localStorage.setItem(SESSION_START_KEY, String(Date.now()));
    }
  }, [signOut]);

  const trackActivity = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    // Initialize session start if not already set
    if (!localStorage.getItem(SESSION_START_KEY)) {
      localStorage.setItem(SESSION_START_KEY, String(Date.now()));
    }
  }, []);

  return { trackActivity };
}
